import { trackEvent } from '@patrianna/analytics'

import AdCashEventService from 'analyticActions/adcash/events'
import BuilderEventService from 'analyticActions/builder/events'
import { IS_BRAND_PULSZ } from 'config/brands'

type TrackDataType = {
  currency: string
  offerCode: string
  city?: string
  zip?: string
  external_id: string
  transactionTotal: number
  transactionId?: string
  value?: number
  provider: string
  userId: string
}

export const trackFirstPurchase = ({
  offerCode,
  city,
  zip,
  external_id,
  transactionTotal,
  transactionId,
  value,
  provider,
  userId,
  currency,
}: TrackDataType) => {
  trackEvent('first_purchase', {
    label: offerCode,
    city,
    zip,
    external_id,
    transactionTotal,
    transactionId,
    value,
    event_id: transactionId,
    currency,
  })

  trackEvent(
    'PlaceAnOrder',
    {
      parameters: {
        value: value,
        currency: currency,
      },
      options: {
        event_id: transactionId,
      },
    },
    { tiktok: true },
  )

  trackEvent(
    'event',
    {
      eventId: IS_BRAND_PULSZ ? 'tw-odo3i-odo41' : '',
      twitterOptions: {
        description: 'Added Payment Info - First Purchase',
        conversion_id: transactionId,
        value: value,
        currency: currency,
      },
    },
    { twitter: true },
  )

  BuilderEventService.trackEvent('first_purchase')
  AdCashEventService.trackEvent('firstPurchase', { value: transactionTotal })
}
